import React, { ComponentProps, FC } from "react"
import BaseButton from "../Base/BaseButton";
type BaseButtonProps = ComponentProps<typeof BaseButton>

interface UseButtonProps extends BaseButtonProps {
}
/**
 * 权限按钮
 * @param props.restProps 原有属性
 * @returns 
 */
const UseButton: FC<UseButtonProps> = (props) => {
  const { ...restProps } = props;
  return <BaseButton {...restProps}></BaseButton>
}
export default UseButton;